/* Mouse drag-to-scroll for the product page's mobile media strip.

   Dawn gives .product__media-list.slider--mobile overflow-x: auto with
   scroll-snap, which a finger drags natively. A mouse cannot drag a native
   scroller, so pointer dragging is added here — for pointerType 'mouse' only,
   leaving touch on the native scroller and its momentum untouched.

   Snapping is disabled for the duration of a drag (a mandatory snap fights
   scrollLeft being written every frame) and restored on release. */
(function () {
  'use strict';

  var DRAG_THRESHOLD = 4; /* px before a press counts as a drag, not a click */

  function wire(list) {
    var down = false;
    var dragged = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;

    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      dragged = false;
      startX = e.clientX;
      startScroll = list.scrollLeft;
      pointerId = e.pointerId;
    });

    list.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < DRAG_THRESHOLD) return;
      if (!dragged) {
        dragged = true;
        list.classList.add('fm-dragging', 'fm-dragged');
        /* Capture so the drag survives the pointer leaving the strip. */
        try { list.setPointerCapture(pointerId); } catch (err) {}
      }
      e.preventDefault();
      list.scrollLeft = startScroll - dx;
    });

    function end(e) {
      if (!down || (e && e.pointerId !== pointerId)) return;
      down = false;
      list.classList.remove('fm-dragging');
      try { list.releasePointerCapture(pointerId); } catch (err) {}
      pointerId = null;
      if (!dragged) return;
      /* Keep clicks suppressed until after this gesture's click event has
         been and gone, then hand interactivity back. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          list.classList.remove('fm-dragged');
        });
      });
    }

    list.addEventListener('pointerup', end);
    list.addEventListener('pointercancel', end);

    /* Native image dragging would otherwise lift a ghost mid-scrub — the same
       trap the carousel hit. */
    list.addEventListener('dragstart', function (e) {
      if (dragged) e.preventDefault();
    });
  }

  function init() {
    var lists = document.querySelectorAll(
      "main[data-template='product'] .product__media-list"
    );
    Array.prototype.forEach.call(lists, wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
